// extracted by mini-css-extract-plugin
module.exports = {"column":"Card_column__3QQ34","row":"Card_row__2p2df","card":"Card_card__3uqLH","container":"Card_container__2f3YX","sub":"Card_sub__wA0OJ"};